<template>
    <el-input 
        v-model="inputValue"
        :size="size"
        :style="{width: width}"
        :placeholder="placeholder"
        :disabled="disabled"
        @change="handleChange">
    </el-input>
</template>
<script>
    /**
     * 输入框，自动搜索填充结果的的组件
     */
    export default {
        name: 'LyQueryInput',
        props: {
            // 绑定的是基本类型字段
            value: [String, Number],
            placeholder: {
                type: String,
                default: '请输入'
            },
            size: {
                type: String,
                default: 'small'
            },
            width: {
                type: String,
                default: '220px'
            },
            disabled: {
                type: Boolean,
                default: false
            },
            /**
             {
                api 接口请求地址
                filed // 获取结果后要绑定的值
             }
             */
            json: Object,
            watchField: { // 监听变化的值，也作为搜索的参数
                type: [String, Number, Object]
            }
        },
        data () {
            return {
                inputValue: ''
            }
        },
        watch: {
            value (v) {
                this.refInputValue(v)
            },
            /**
             * 搜索关联字段，值变化的监听
             * @param  {[type]} v [description]
             * @return {[type]}   [description]
             */
            watchField (v) {
                if (v) {
                    this.queryData()
                }
            }
        },
        methods: {
            /**
             * 更新autoValue的值
             */
            refInputValue (v) {
                if (v && v !== this.inputValue) {
                    this.inputValue = v
                }
            },
            /**
             * 数据的获取
             * @return {[type]} [description]
             */
            queryData () {
                this.$api.query(this.json.api, this.watchField).then((rs) => {
                    this.inputValue = rs[this.json.filed]
                    this.handleChange(this.inputValue)
                }).catch((err) => {
                    console.error('query-input query error:%O', err)
                })
            },
            /**
             * 值的变化
             */
            handleChange (val) {
                if (val !== this.value) {
                    this.$emit('input', val)
                }
            }
        }
    }
</script>